module.exports = __webpack_public_path__ + "media/images/icons/outlined/compass-696c213d61e4e6d11ddd7a13c1a08021.svg";